/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Delete_Account_ConfirmInputs */

const en_settings_delete_account_confirm = /** @type {(inputs: Settings_Delete_Account_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your email address to confirm deletion:`)
};

const de_settings_delete_account_confirm = /** @type {(inputs: Settings_Delete_Account_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie Ihre E-Mail-Adresse ein, um die Loeschung zu bestaetigen:`)
};

const fr_settings_delete_account_confirm = /** @type {(inputs: Settings_Delete_Account_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez votre adresse e-mail pour confirmer la suppression :`)
};

const es_settings_delete_account_confirm = /** @type {(inputs: Settings_Delete_Account_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce tu direccion de correo electronico para confirmar la eliminacion:`)
};

const it_settings_delete_account_confirm = /** @type {(inputs: Settings_Delete_Account_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci il tuo indirizzo e-mail per confermare l'eliminazione:`)
};

const nl_settings_delete_account_confirm = /** @type {(inputs: Settings_Delete_Account_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer uw e-mailadres in om de verwijdering te bevestigen:`)
};

const pl_settings_delete_account_confirm = /** @type {(inputs: Settings_Delete_Account_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wpisz swoj adres e-mail, aby potwierdzic usuniecie:`)
};

const fi_settings_delete_account_confirm = /** @type {(inputs: Settings_Delete_Account_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Syötä sähköpostiosoitteesi vahvistaaksesi poiston:`)
};

const da_settings_delete_account_confirm = /** @type {(inputs: Settings_Delete_Account_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indtast din e-mailadresse for at bekraefte sletning:`)
};

const sv_settings_delete_account_confirm = /** @type {(inputs: Settings_Delete_Account_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ange din e-postadress for att bekrafta raderingen:`)
};

/**
* | output |
* | --- |
* | "Enter your email address to confirm deletion:" |
*
* @param {Settings_Delete_Account_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_delete_account_confirm = /** @type {((inputs?: Settings_Delete_Account_ConfirmInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Delete_Account_ConfirmInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_delete_account_confirm(inputs)
	if (locale === "fr") return fr_settings_delete_account_confirm(inputs)
	if (locale === "es") return es_settings_delete_account_confirm(inputs)
	if (locale === "it") return it_settings_delete_account_confirm(inputs)
	if (locale === "nl") return nl_settings_delete_account_confirm(inputs)
	if (locale === "pl") return pl_settings_delete_account_confirm(inputs)
	if (locale === "fi") return fi_settings_delete_account_confirm(inputs)
	if (locale === "da") return da_settings_delete_account_confirm(inputs)
	if (locale === "sv") return sv_settings_delete_account_confirm(inputs)
	return en_settings_delete_account_confirm(inputs)
});